<!-- <p>dashboard-panel-template works!</p> -->
<app-dialog-header headerText="Choose Dashboard Panel Template" (onCloseClick)="onCancelClick()"></app-dialog-header>
<form [formGroup]="dialogForm">
    <div class="dialog-div" [ngStyle]="{'width': isMobile ? '80vw' : ''}">
        <div class="content">
            <ejs-tab id="element" [headerPlacement]="'Left'" (selected)="tabSelected($event)" height="100%">
                <e-tabitems>
                    <e-tabitem *ngFor="let template of templates">
                        <ng-template #headerText>
                            <div class="alignRow">
                                <mat-icon>{{getIconForTemplate(template)}}</mat-icon>
                                <span class="tab-header">&nbsp;{{template.text}}</span>
                            </div>
                        </ng-template>
                        <ng-template #content>
                            <div style="height: 100%;">
                                <!-- <div class="dropdown-container">
<ejs-dropdownlist id="dropdown" #dropdown [dataSource]='templates' [fields]="templateFields"
formControlName="template" [(value)]="selectedTemplate" (change)="setMetricNumberOptions($event)">
<ng-template #itemTemplate let-data>
<div>
<span>{{ data.text }}</span>
</div>
</ng-template>
</ejs-dropdownlist>
</div> -->
                                <div class="example">
                                    <ng-container [ngTemplateOutlet]="getTemplate(selectedTemplate)"></ng-container>
                                </div>
                                <div class="options alignRow" *ngIf="selectedTemplate != -1 && selectedTemplate != 4">
                                    <span>Number of {{(!isHierarchyNode && ([1,5,6].includes(selectedTemplate))) ||
                                        (isHierarchyNode &&
                                        ([1,9,10].includes(selectedTemplate))) ? 'Ranges' : 'Metrics'}}</span>
                                    <div class="dropdown-container">
                                        <ejs-dropdownlist id="dropdownMetrics" #dropdownMetrics
                                            [dataSource]='numMetricOptions' [fields]="templateFields"
                                            formControlName="numberOfMetrics" placeholder="Select Number of {{(!isHierarchyNode && ([1,5,6].includes(selectedTemplate))) ||
                                        (isHierarchyNode &&
                                        ([1,9,10].includes(selectedTemplate))) ? 'Ranges' : 'Metrics'}} to Show"
                                            [(value)]="selectedNumberOfMetrics">
                                            <ng-template #itemTemplate let-data>
                                                <div>
                                                    <span>{{ data.text }}</span>
                                                </div>
                                            </ng-template>
                                        </ejs-dropdownlist>
                                    </div>
                                </div>
                                <div class="metrics"
                                    *ngIf="selectedTemplate == 4 || selectedTemplate == 1 || selectedNumberOfMetrics">
                                    <ng-container
                                        *ngIf="(!isHierarchyNode && (![1,5,6].includes(selectedTemplate))) || (isHierarchyNode && (![1,9,10].includes(selectedTemplate)))">
                                        <div class="dropdown-container"
                                            [ngStyle]="{'grid-column': (selectedNumberOfMetrics % 2 != 0) && idx == 0 ? '1 / -1' : ''}"
                                            *ngFor="let i of [].constructor(selectedNumberOfMetrics); let idx = index">
                                            <ejs-dropdownlist *ngIf="selectedTemplate != 4" #dropdownMetricChoice
                                                [dataSource]='templateMetrics[selectedTemplate].metrics'
                                                [fields]="templateFields" [formControlName]="'metric' + (idx + 1)"
                                                [placeholder]="'Choose Metric ' + (idx + 1)">
                                                <ng-template #itemTemplate let-data>
                                                    <div>
                                                        <span>{{ data.text }}</span>
                                                    </div>
                                                </ng-template>
                                            </ejs-dropdownlist>
                                        </div>
                                    </ng-container>
                                    <ng-container
                                        *ngIf="(!isHierarchyNode && ([1,5,6].includes(selectedTemplate))) || (isHierarchyNode && ([1,9,10].includes(selectedTemplate)))">
                                        <ng-container
                                            *ngFor="let j of [].constructor(!isTotalising ? selectedDatapoints.length : 1); let dpidx = index">
                                            <span class="dp-title">{{!isTotalising ? selectedDatapoints[dpidx].DPTitle :
                                                'Totalised Gauge'}}</span>
                                            <ng-container *ngIf="selectedNumberOfMetrics">
                                                <div class="dropdown-container" style="grid-column: 1 / -1;"
                                                    *ngFor="let i of [].constructor(selectedNumberOfMetrics); let idx = index">
                                                    <div class="linear-gauge-range-picker alignRow">
                                                        <ejs-dropdownlist #dropdownMetricChoice
                                                            [dataSource]='getTemplateMetrics(selectedTemplate)'
                                                            [fields]="templateFields"
                                                            [formControlName]="'metric' + (idx + 1)"
                                                            [placeholder]="'Choose Range ' + (idx + 1)"
                                                            (change)="rangeNameChange($event, (idx+1), dpidx)">
                                                            <ng-template #itemTemplate let-data>
                                                                <div>
                                                                    <span>{{ data.text }}</span>
                                                                </div>
                                                            </ng-template>
                                                        </ejs-dropdownlist>
                                                        <ejs-numerictextbox [step]="1" cssClass="e-custom"
                                                            placeholder="Min"
                                                            (change)="rangeChange($event, (idx + 1), true, dpidx)">
                                                        </ejs-numerictextbox>
                                                        <ejs-numerictextbox [step]="1" cssClass="e-custom"
                                                            placeholder="Max"
                                                            (change)="rangeChange($event, (idx + 1), false, dpidx)">
                                                        </ejs-numerictextbox>
                                                        <div class="alignRow">
                                                            <span>Colour</span>
                                                            <input ejs-colorpicker id='color-picker' type='color'
                                                                value="#ffffff"
                                                                (change)="colourChange($event, (idx + 1), dpidx)" />
                                                        </div>
                                                        <div class="alignRow">
                                                            <span>Creates Tile Border</span>
                                                            <mat-checkbox color="primary"
                                                                (change)="borderChange($event, (idx + 1), dpidx)"></mat-checkbox>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                    <div style="padding: 1em; grid-column: 1 / -1;">
                                        <div [ngClass]="{'dp-box': !isHierarchyNode}"
                                            *ngIf="(isHierarchyNode && node && [0,1,2,3,9,10].includes(selectedTemplate) || !isHierarchyNode && node && [1,5,6].includes(selectedTemplate))">
                                            <ejs-multiselect [mode]="'Box'" [fields]='dpFields'
                                                placeholder="Choose Datapoints to Include" [showSelectAll]='true'
                                                [dataSource]="datapoints" formControlName="datapoints"
                                                (change)="datapointChoiceChange($event)"></ejs-multiselect>
                                            <mat-checkbox color="primary" *ngIf="!isHierarchyNode"
                                                [formControlName]="'totalise'"
                                                (change)="toggleTotalising($event)">Totalise</mat-checkbox>
                                        </div>
                                        <div class="dpError" *ngIf="notValid">Panel can only contain DataPoints with the
                                            same units.</div>
                                        <ejs-dropdownlist *ngIf="selectedTemplate == 4" #dropdownDashboards
                                            [dataSource]='existingDashboards' [fields]="dashboardFields"
                                            [formControlName]="'metric1'" placeholder="Choose Shortcut Destination">
                                            <ng-template #itemTemplate let-data>
                                                <div>
                                                    <span>{{ data.DashboardName }}</span>
                                                </div>
                                            </ng-template>
                                        </ejs-dropdownlist>
                                        <div *ngIf="(isHierarchyNode && node && selectedTemplate == 11)">
                                            <ejs-multiselect [mode]="'Box'" [fields]='whFields'
                                                placeholder="Choose Webooks to Include (All if none selected)"
                                                [showSelectAll]='true' [dataSource]="webhooks"
                                                formControlName="webhooks"
                                                (change)="webhookChoiceChange($event)"></ejs-multiselect>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </e-tabitem>
                </e-tabitems>
            </ejs-tab>
        </div>
        <div mat-dialog-actions>
            <button mat-button (click)="onDialogClose()" [disabled]="dialogForm.invalid || notValid">Ok</button>
            <button mat-button (click)="onCancelClick()" cdkFocusInitial>Cancel</button>
        </div>
    </div>
</form>